import { TYPE_CPF, TYPE_CNPJ } from "@hub/order/src/constants"
import { fetchCompanyTypes } from "@hub/order/src/services/client.service"

export default {
  fillClient({ commit }, client) {
    if (client.type === TYPE_CPF) {
      commit("setDocument", client.cpf || "")
      commit("setType", client.type || 0)
      commit("setRG", client.rg || "")
      commit("setGeneralRegistrationExempt", client.generalRegistrationExempt || false)
      commit("setName", client.fullName || "")
      commit("setBirthDate", client.birthDate || "")
      commit("setMotherName", client.motherName || "")
      commit("setFatherName", client.fatherName || "")
      commit("setGender", client.gender || "")
      commit("setSchooled", client.schooled)
      commit("setMaritalStatus", client.maritalStatus || "")
      commit("setProfession", client.profession || "")
      commit("setProfessionName", client.professionName || "")
      commit("setEmail", client.email || "")
      commit("setCellphone", client.cellPhone || "")
      commit("setLandline", client.landline || "")
      commit("setAnotherContact", client.anotherContact || "")
      commit("setWhatsappContact", client.whatsappContact || "")
      commit("setIsAnotherContactReturnedFilled", Boolean(client.anotherContact))
      commit("setContactType", client.contactType || {})
      commit("setCustomerOrigin", client.customerOrigin || null)
    }
    if (client.type === TYPE_CNPJ) {
      commit("setDocument", client.cnpj || "")
      commit("setType", client.type || 0)
      commit("setCompanyName", client.companyName || "")
      commit("setCompanyType", client.companyType || "")
      commit("setCompanyState", client.companyState || 0)
      commit("setOpeningDate", client.openingDate || "")
      commit("setStateId", client.stateId || "")
      commit("updateLegalResponsibles", client.legalResponsibles || [])
      commit("setResponsibleName", client.representativeName || "")
      commit("setResponsibleCpf", client.representativeCpf || "")
      commit("setState", client.state || "")
      commit("setStateRegistration", client.stateRegistration || "")
      commit("setExempt", !client.stateRegistration)
      commit("setEmail", client.email || "")
      commit("setCellphone", client.cellPhone || "")
      commit("setLandline", client.landline || "")
      commit("setAnotherContact", client.anotherContact || "")
      commit("setIsAnotherContactReturnedFilled", Boolean(client.anotherContact))
      commit("setWhatsappContact", client.whatsappContact || "")
      commit("setContactName", client.contactName || "")
      commit("setContactType", client.contactType || {})
      commit("updateIsCompanyTypeFromBepeople", client.isCompanyTypeFromBepeople || false)
      commit("updateIsCompanyStateFromBepeople", client.isCompanyStateFromBepeople || false)
      commit("setCustomerOrigin", client.customerOrigin || null)
    }
  },

  async fetchCompanyTypesOptions({ commit, getters }) {
    try {
      if(getters.getCompanyTypesOptions && getters.getCompanyTypesOptions?.length > 0) {
        return
      }

      const options = await fetchCompanyTypes({active: 1})

      const formattedOptions = options?.map(t => ({
        text: t.description,
        value: t.id,
        code: t.code
      }))

      commit('updateCompanyTypesOptions', formattedOptions)
    } catch (error) {
      console.error(error)
    }
  }
}
